import { Form } from 'react-bootstrap';

export const SmartActionsSection = ({
  selectedIsSmartActionsEnabled,
  handleSmartActionsChange
}) => {
  return (
    <Form.Group className="text-start mt-2" controlId="isSmartActionsEnabled">
      <div className="d-flex align-items-center justify-content-between">
        <Form.Label><strong>SMART ACTIONS</strong></Form.Label>
        <div className="d-flex align-items-center gap-3 my-2">
          <Form.Check
            type="switch"
            id="smartActions-toggle"
            checked={selectedIsSmartActionsEnabled}
            onChange={handleSmartActionsChange}
          />
          <span>{selectedIsSmartActionsEnabled ? "Enabled" : "Disabled"}</span>
        </div>
      </div>
    </Form.Group>
  );
};